import { laptopMaxXL, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import { Label } from '../inputs/Checkbox.style';

export const ImportantPlace = styled.div`
  padding: 12px 18px;
  border-radius: 5px;
  border: solid 1px #d9d9d9;
  background-color: ${({ theme }) => theme.white};
`;

export const PlaceBadge = styled.div`
  border-radius: 5px;
  font-size: 15px;
  margin: 25px 0 0;
  padding: 8px;
  background-color: ${({ theme }) => theme.backgroundLightest};
  display: inline-block;
  width: fit-content;
`;

export const ImportantPlacesContainer = styled.div<{ $grid?: boolean }>`
  ${({ $grid }) =>
    $grid
      ? css`
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 30px;

          @media (${laptopMaxXL}) {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 20px;
          }

          @media (${mobileXXLargeMax}) {
            grid-template-columns: repeat(1, minmax(0, 1fr));
            gap: 10px;
          }
        `
      : css`
          padding: 10px;
          ${ImportantPlace}:not(:last-child) {
            margin-bottom: 16px;
            padding: 8px;
          }
          ${PlaceBadge} {
            margin: 8px 0;
          }
        `}
`;

export const PlaceContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const PlaceHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
  align-items: center;
  margin-bottom: 12px;
`;

export const PlaceMarker = styled.img`
  max-width: none;
  max-height: none;
  width: auto;
  padding: 0;
  align-self: flex-start;
`;

export const PlaceContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const DeleteBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 5px;
  background-color: #d9d9d9;
  color: #757575;
  transition:
    background-color 150ms linear,
    color 150ms linear;

  svg {
    display: block;
  }

  &:hover {
    background-color: ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.white};
  }
`;

export const LoadingBox = styled.div<{ bg?: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  background-color: ${({ theme }) => theme.white};
  border-radius: 8px;
`;

export const PlaceFooter = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
`;

export const AddToSearch = styled.div`
  display: flex;
  align-items: center;

  > :not(:last-child) {
    margin-right: 8px;
  }

  ${Label} {
    cursor: pointer;
  }
`;
